import usePermissions from "hooks/usePermissions";
import useLicenseCheck from "license/useLicenseCheck";
import AppConfig from "util/AppConfig";
export const HEALTH_MODULE_PERMISSIONS = ["clusterhealth:read", "clusterconfiguration:read"];
const useHealthModuleVisible = () => {
  const {
    enterprise: { isValid: hasEnterpriseLicense }
  } = useLicenseCheck();
  const { isPermitted } = usePermissions();
  return hasEnterpriseLicense && isPermitted(HEALTH_MODULE_PERMISSIONS) && !AppConfig.isCloud();
};
export default useHealthModuleVisible;
